// LanguageSwitcher.jsx
import React, { useEffect, useRef, useState } from "react";
import i18n from "../../i18n";

export default function LanguageSwitcher({
  className = "langSwitch",
  showMarks = false, // mettre à true si tu veux les deux petits traits décoratifs
}) {
  const [current, setCurrent] = useState(
    i18n.language?.startsWith("en") ? "en" : "fr"
  );
  const prev = useRef(current);
  const [swapClass, setSwapClass] = useState("");

  // 🔔 écoute la langue pour re-render + animation
  useEffect(() => {
    const handler = (lng) => {
      const next = lng?.startsWith("en") ? "en" : "fr";
      const dir = next === "en" ? "swap-to-en" : "swap-to-fr";
      setCurrent(next);
      setSwapClass(dir);
      clearTimeout((handler._t));
      handler._t = setTimeout(() => setSwapClass(""), 320);
      prev.current = next;
    };
    i18n.on("languageChanged", handler);
    return () => {
      i18n.off("languageChanged", handler);
      clearTimeout(handler._t);
    };
  }, []);

  const change = (lng) => {
    // lance le changement (async) → l'écouteur ci-dessus fera le reste
    i18n.changeLanguage(lng);
  };

  return (
    <div
      className={`${className} ${swapClass} ${showMarks ? "with-marks" : ""}`}
      role="group"
      aria-label="Language selector"
    >
      <button
        className={`lang fr ${current === "fr" ? "active" : ""}`}
        onClick={() => change("fr")}
        aria-pressed={current === "fr"}
        title="Passer en français"
      >
        FR
      </button>

      <button
        className={`lang en ${current === "en" ? "active" : ""}`}
        onClick={() => change("en")}
        aria-pressed={current === "en"}
        title="Switch to English"
      >
        EN
      </button>
    </div>
  );
}
